import { server } from "@/state/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/informes")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ul>
      <li>
        <a href={`${server}/admin/informes/ubicaciones`} target="_blank">
          Ubicaciones
        </a>
      </li>
      <li>
        <a href={`${server}/admin/ranking`} target="_blank">
          Ranking
        </a>
      </li>
      <li>
        <a href={`${server}/admin/comparar_temporadas`} target="_blank">
          Comparar temporadas
        </a>
      </li>
      <li>
        {" "}
        <a href={`${server}/admin/informes/fotos_vendidas`} target="_blank">
          Fotos vendidas
        </a>
      </li>
    </ul>
  );
}
